import { InjectionToken } from '@angular/core';
import { LocaleEnum } from '@wizbii/utils/models';

export interface ServicesConfigInterface {
  locale: LocaleEnum;
}

export const SERVICES_STATE_CONFIG = new InjectionToken<ServicesConfigInterface>('ServicesState configuration', {
  providedIn: 'root',
  factory: () => ({
    locale: undefined as any,
  }),
});
